module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_down.7b31d.png";